<template>
  <div class="link disabled" :style="inputStyle" v-if="link.disable">
    <span :title="link.title || '不在比赛时间内'">{{link.text}}</span>
  </div>
  <div class="link" :style="inputStyle" @click="navigate" v-else>
    {{link.text}}
  </div>
</template>

<script>
 export default {
   name: '',
   props: [
     'link',
     'inputStyle',
   ],
   computed: {
     user() {
       return this.$store.state.auth.user;
     }
   },
   methods: {
     jump() {
       if(this.user){
         if(this.user.enrolled)
           {
             window.open(this.$store.state.gamelink+this.$store.state.auth.token.token + `&redirect=${encodeURIComponent('/ai/course-instance/68c0f825937d34b59be6a415')}`, "_blank")
           }
         else
           {
             this.$router.push({name: 'enroll'})
           }
       }
       else
         {
           this.$router.push({name:'account', params:{type:'login'}})
         }
     },

     navigate () {
       if(this.link.disable)
         return
       if (this.link.link == 'hackstack') {
         return this.jump()
       }
       if(this.link.link == 'startGame')
         {
           this.jump()
           return;
         }
       if(typeof this.link.link === 'object')
         this.$router.push(this.link.link)
       else
         window.open(this.link.link, "_blank")
     }
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .link {
   display: flex;
   justify-content: center;
   align-items: center;
   cursor: pointer;
 }
 .disabled{
   cursor: not-allowed !important;
 }
</style>
